<template>

    <div>
        
        <Button
            :size="15"
            color="#dc3545"
            colorText="#ffffff"
            tooltip="Eliminar planificación"
            icon="fas fa-times"
            round
            :width="35"
            class="mr-2"
            @click.native="checkPlanificacionAnual.length > 0 ? openModal('modal') : ''"
            traslate
            :inactive="checkPlanificacionAnual.length > 0 ? false : true"
        />

        <ui-modal ref="modal" size="large" title="Eliminar puerto de destino" @close="clear">

            <table class="table table-striped">
                <thead>
                    <th class="text-center">Puerto destino</th>
                    <th class="text-center">Contenedor</th>
                    <th class="text-center">Tipo producto</th>
                    <th class="text-center">Carga anual</th>
                </thead>
                <tbody>
                    <tr v-for="(fila, index_fila) in checkPlanificacionAnual" :key="index_fila">
                        <td class="text-center" v-text="fila.data.data[0]"></td>
                        <td class="text-center" v-text="fila.data.data[1]"></td>
                        <td class="text-center" v-text="fila.data.data[2]"></td>
                        <td class="text-center" v-text="fila.data.data[4]"></td>
                    </tr>
                </tbody>
            </table>

            <div class="d-flex justify-content-between">
                <Button
                    :size="25"
                    color="#898476"
                    colorText="#ffffff"
                    tooltip="Modificar planificación"
                    text="Cancelar"
                    :width="130"
                    :height="35"
                    class="mr-2"
                    @click.native="closeModal('modal')"
                />

                <Button
                    :size="25"
                    color="#dc3545"
                    colorText="#ffffff"
                    tooltip="Eliminar puerto"
                    text="Eliminar"
                    :width="130"
                    :height="35"
                    class="mr-2"
                    @click.native="eliminar"
                />
            </div>

        </ui-modal>

    </div>
  
</template>

<script>

    // Vue
    import Vue from "vue";

    // Toast
    import VueToastify from "vue-toastify";
    Vue.use(VueToastify);
    
    import { mapActions, mapState } from 'vuex'

    // Keen UI
    import UiModal from "keen-ui/src/UiModal";

    import Button from '../../../common/Button.vue'

    // API
    import { eliminarPuertos } from '../../../../constants/lineas';

    export default {
        props : ['data'],
        data(){
            return {
            }
        },
        components: { Button, UiModal },
        computed : {
            ...mapState('lineas',['habilitarEdicionMultipleAnual','puertosSeleccionadosPlanAnual','checkPlanificacionAnual']),
        },
        methods : {

            ...mapActions('lineas',['actionSetDataPlanificacionAnualTabla']),

            openModal(ref) {
                this.$refs[ref].open();
            },

            closeModal(ref) {
                this.$refs[ref].close();
            },

            async eliminar(){

                let data = [];

                this.$vToastify.loader('Eliminando puertos');

                this.checkPlanificacionAnual.map( item => {
                    let {data_complementaria, new : isNew} = item.data;
                    !isNew && data.push({ "plan_id":data_complementaria.annual_plan_id, "port_id":data_complementaria.port_id});
                });

                const sql = await eliminarPuertos({ "plans" : data });
                
                if (sql.code == 200) {
                    this.closeModal('modal');
                    this.actionSetDataPlanificacionAnualTabla();
                    this.$vToastify.stopLoader();
                    this.$vToastify.success( sql.message, "Proceso finalizado");
                } else {
                    this.$vToastify.stopLoader();
                    this.$vToastify.error( sql.message, "Proceso finalizado");
                }

            },

            clear(){



            }
        },
    }
</script>
